<scaffold-dialog>
  <div scaffoldDialogBody>
    <div [ngSwitch]="data.type">
      <div *ngSwitchCase="'youtube'">
        <app-youtube-search (selectItem)="setSelected($event)" [data]="data"></app-youtube-search>
      </div>
      <div *ngSwitchCase="'data_search'">
        <app-data-search (selectItem)="setSelected($event)" [data]="data"></app-data-search>
      </div>
      <div *ngSwitchCase="'data_link'">
        <app-data-search (selectItem)="setSelected($event)" [data]="data"></app-data-search>
      </div>
      <div *ngSwitchCase="'data_link_label'">
        <app-data-search (selectItem)="setSelected($event)" [data]="data"></app-data-search>
      </div>
      <div *ngSwitchCase="'data_link_count'">
        <app-data-search (selectItem)="setSelected($event)" [data]="data"></app-data-search>
      </div>
    </div>
  </div>
  <div scaffoldDialogButtons>
    <button nbButton status="neutral" (click)="dialogRef.close()">{{'cancel'|translation}}</button>
    <button *ngIf="(data.type=='data_search' || data.type=='data_link' || data.type=='data_link_count' || data.type=='data_link_label') && !data.prevent_create" nbButton status="primary" (click)="createData(data.search_type,data.context)">{{'create_new'|translation}}</button>
    <button nbButton status="primary" (click)="closeDialog(this.selected)" [disabled]="!this.selected">{{'use_selected'|translation}}</button>

  </div>
</scaffold-dialog>
